export function getCombinedOlId(themeId, layerId) {
    if (!themeId) {
        return layerId;
    }
    return `${themeId}-${layerId}`;
}

export function updateLayerStyles(currentUserMap, layerDataResult, theme) {
    for (const layer of layerDataResult.data.themeLayers) {

        // for every layer in the theme see if there is a sortedLayer with a selectedStyle in the current usermap.
        const sortedLayer = currentUserMap.content.sortedLayers.find(sl => sl.themeLayerId === layer.id
            && sl.themeId === theme.id
            && sl.selectedStyle);

        // update layer stylename with selectedstyle from usermap.
        // when sortedlayer is present for current layer and selectedStyle has a value
        if (sortedLayer && sortedLayer.selectedStyle) {
            // Check if sortedlayer.selectedStyle is a current style for the WMS
            const wmsStyles = theme.data.themeLayers.find(tl => tl.id === layer.id).wmsStyles;
            if (wmsStyles && wmsStyles.includes(sortedLayer.selectedStyle)) {
                layer.styles[0].name = sortedLayer.selectedStyle;
            }
        }
    }
}
